// src/pages/History/EarlyModern/ColumbianExchange.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Early_Modern_Period_-_Columbian_Exchange.png';

function HistoryPageColumbianExchange() {
  return (
    <TopicPage
      topicKey="Columbian Exchange"
      title="History: Columbian Exchange"
      backgroundImage={bg}
      startRoute="/History-Columbian-Exchange-Go"
      scrollLabels={[
        "Old World vs New World Crops",
        "Impact on Indigenous Peoples",
        "Global Economic and Cultural Effects",
      ]}
      backRoute="/history-early-modern"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageColumbianExchange;
